import type { App } from "vue";
import {
  ProfileDataSourceImpl,
  profileDataSourceKey,
} from "./data/datasources/profile_datasource";

export function initProfileModule(app: App) {
  app.provide(profileDataSourceKey, new ProfileDataSourceImpl());
}
